// extracted by mini-css-extract-plugin
export const song__thumbnail = "SongMedia-module--song__thumbnail--XdAvD";
export const song__video = "SongMedia-module--song__video--w7b6-";
export const song__video_placeholder = "SongMedia-module--song__video_placeholder--IjBFV";
export const song__artists = "SongMedia-module--song__artists--3G3Mh";
export const song__artist_card = "SongMedia-module--song__artist_card--22SF-";
export const selected = "SongMedia-module--selected--2WCNP";
export const song__artist_avatar = "SongMedia-module--song__artist_avatar--1Ix-K";
export const song__artist_name = "SongMedia-module--song__artist_name--1mbnu";
export const song__check_author = "SongMedia-module--song__check_author--o_Nsg";